import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Skeleton, Stack, styled } from '@mui/material'
import type { FC, PropsWithChildren } from 'react'
import type { To } from 'react-router'

import { COLORS, ICONS, LinkUnstyled, serratedEdgeHorizontalCss, remUnit, unit, Z_INDEX } from '@hcr/ui'

import { LayoutBase } from '../../../../common'

interface LayoutBackNavigateCouponLoadingProps extends PropsWithChildren {
  to: To
}

export const LayoutBackNavigateCouponLoading: FC<LayoutBackNavigateCouponLoadingProps> = ({ to }) => {
  return (
    <LayoutBase>
      <Box sx={{ padding: `0 ${unit(3)} ${unit(3)}}` }}>
        <ArrowLinkIcon to={to} sx={{ backgroundColor: COLORS.white, border: `${unit(0.5)} solid ${COLORS.black}` }}>
          <FontAwesomeIcon icon={ICONS.farArrowLeft} />
        </ArrowLinkIcon>

        <Box css={serratedEdgeHorizontalCss} bgcolor={COLORS.ruoho['60%']} paddingBottom={unit(8)}>
          <Skeleton width='100%' height={unit(60)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
          <Stack sx={{ gap: unit(3), alignItems: 'center', paddingTop: unit(7) }}>
            <Skeleton width={unit(8)} height={unit(8)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width={unit(10)} height={unit(2)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width={unit(20)} height={unit(4)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
          </Stack>

          <Stack sx={{ padding: unit(4), textAlign: 'center', alignItems: 'center' }}>
            <Skeleton width={unit(50)} height={unit(12)} sx={{ bgcolor: COLORS.grey }} />
          </Stack>

          <Stack sx={{ gap: unit(3), paddingTop: 0, padding: unit(4), alignItems: 'center', textAlign: 'center' }}>
            <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.grey }} />
          </Stack>

          <Stack
            sx={{ gap: unit(4), justifyContent: 'center', alignItems: 'center', paddingTop: unit(7), padding: unit(4) }}
          >
            <Skeleton width='90%' height={unit(40)} sx={{ bgcolor: COLORS.grey }} variant='rectangular' />
            <Skeleton width={unit(40)} height={unit(6)} sx={{ bgcolor: COLORS.grey }} />
          </Stack>
        </Box>
      </Box>
    </LayoutBase>
  )
}

const ArrowLinkIcon = styled(LinkUnstyled)`
  width: ${unit(14)};
  height: ${unit(14)};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: ${unit(6)};
  top: ${unit(4)};
  z-index: ${Z_INDEX.navigation};
  font-size: ${remUnit(6)};
`
